<template>
  <div class="index">
    <el-row style="display: flex">
      <el-col :span="3" class="index-left">
        <el-collapse v-model="activeNames" accordion>
          <p
            :key="index"
            style="
              font-family: PingFangSC-Regular, PingFang SC;
              line-height: 38px;
              cursor: pointer;
              font-size: 14px;
            "
            :class="{ acitve: nowActive == index }"
            @click="nowActive = index"
            v-for="(page, index) in pages"
          >
            {{ page }}
          </p>
          <!-- <el-collapse-item :name="1" title="系统集成">
          </el-collapse-item> -->
        </el-collapse>
      </el-col>
      <el-col :span="21" class="index-right">
        <!-- <workweixin v-if="nowActive == 0"> 1 </workweixin> -->
        <officialaccount v-if="nowActive == 0"></officialaccount>
        <weixinapi v-if="nowActive == 1"> 2 </weixinapi>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import workweixin from "../components/system/workWexin";
import weixinapi from "../components/system/wexinApi";
import officialaccount from "../components/system/WeChatOfficialAccount";

export default {
  name: "index",
  components: {
    workweixin,
    weixinapi,
    officialaccount,
  },
  data() {
    return {
      activeNames: 1,
      pages: ["集成到公众号", "开放API"],
      nowActive: 0,
    };
  },
  methods: {},
  mounted() {},
};
</script>
;
<style lang="less" scoped>
.acitve {
  color: #3bc492;
}

.index {
  padding: 10px 10px 0;
}

.index-left {
  min-width: 160px !important;
  height: calc(100vh - 81px);
  border-radius: 8px;
  overflow-y: overlay;
  background: #fff;
  padding: 15px;
  margin-right: 10px;
}
.index-right {
  background: #fff;
  padding: 25px 15px;
  height: calc(100vh - 81px);
  border-radius: 8px;
  overflow: auto;
}
/deep/.el-collapse {
  border: none;
}
</style>
